import axios from "axios";
import { enums } from "../../constants/enum";
const ENDPOINT_KEY = "item";
const ENDPOINT_URI = "/item";

export default function useItemService() {
  return {
    queryKey: ENDPOINT_KEY,
    getAllItems: async ({
      search = "",
      sph,
      cyl,
      add,
      lenseDiagonal,
      bridge,
      armLength,
      accessoryType,
      material,
      color,
      gender,
      modelNumber,
      sunglassFrameColor,
      sunglassLenseColor,
      lenseType,
      minPrice,
      maxPrice,
      page = 1,
      limit = 10,
      sort = enums.ITEM_SORTING_OPTIONS.NEWEST_FIRST,
      stockStatus = enums.ITEM_FILTER_STOCK_STATUS.ALL,
      category = enums.ITEM_FILTER_CATEGORIES.ALL,
    }) => {
      const params = new URLSearchParams({
        page,
        limit,
        sort,
        stockStatus,
        category,
      });
      if (search) {
        params.append("search", search);
      }
      if (minPrice) {
        params.append("minPrice", minPrice);
      }
      if (maxPrice) {
        params.append("maxPrice", maxPrice);
      }
      if (sph) {
        params.append("sph", sph);
      }
      if (cyl) {
        params.append("cyl", cyl);
      }
      if (add) {
        params.append("add", add);
      }
      if (lenseDiagonal) {
        params.append("lenseDiagonal", lenseDiagonal);
      }
      if (bridge) {
        params.append("bridge", bridge);
      }
      if (armLength) {
        params.append("armLength", armLength);
      }
      if (accessoryType) {
        params.append("accessoryType", accessoryType);
      }
      if (material) {
        params.append("material", material);
      }
      if (color) {
        params.append("color", color);
      }
      if (gender) {
        params.append("gender", gender);
      }
      if (modelNumber) {
        params.append("modelNumber", modelNumber);
      }
      if (sunglassFrameColor) {
        params.append("sunglassFrameColor", sunglassFrameColor);
      }
      if (sunglassLenseColor) {
        params.append("sunglassLenseColor", sunglassLenseColor);
      }
      if (lenseType) {
        params.append("lenseType", lenseType);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, {
        params,
      });
      return response.data.payload;
    },
    getItemStatistics: async () => {
      const response = await axios.get(`${ENDPOINT_URI}/statistics`);
      return response.data.payload;
    },
    getItemById: async (itemId) => {
      const response = await axios.get(`${ENDPOINT_URI}/${itemId}`);
      return response.data.payload;
    },
    createItem: async ({ item }) => {
      const response = await axios.post(`${ENDPOINT_URI}/`, item);
      return response.data.payload;
    },
    updateItem: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    deleteItem: async (itemId) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${itemId}`);
      return response.data.payload;
    },
  };
}
